const { composeMiddleware } = require("lib/core/routing/middleware")

export const createCardRoutes = function (root, cards, primaryFallback) {
  if (primaryFallback == null) {
    primaryFallback = null
  }
  const createStackCard = (cardStack, card, key, path) => ({
    key,
    path,
    reversePath: card.reversePath || "../",
    middleware: card.middleware,
    leaveMiddleware: card.leaveMiddleware,
    // Ensure each card is assigned a getDefaultLaunchedFrom fn, passing it down from
    // the top card (though, the top card might not have one defined...).
    getDefaultLaunchedFrom:
      card.getDefaultLaunchedFrom ||
      cardStack.slice(-1)[0]?.getDefaultLaunchedFrom ||
      null,
    component: card.component
  })

  const getCardStackMiddleware = function (cards) {
    const middleware = []
    for (let card of Array.from(cards)) {
      if (_.isFunction(card.middleware)) {
        middleware.push(card.middleware)
      }
    }
    return middleware
  }

  const getCardStackLeaveMiddleware = function (cards) {
    const middleware = []
    for (let card of Array.from(cards)) {
      if (_.isFunction(card.leaveMiddleware)) {
        middleware.push(card.leaveMiddleware)
      }
    }
    return middleware
  }

  const toPathList = (value) => (Array.isArray(value) ? value : [value])

  const normalizeCardPath = (path) =>
    // Ensure a final "/" but only if the path does not end with a ")"
    path.replace(/([^)]$)/, "$1/").replace(/\/+$/, "/")

  const getCardPaths = function (basePath, key, card) {
    // allow card to reset basePath
    basePath = card.basePath || basePath
    const segments = card.path ? toPathList(card.path) : [key]
    return segments.map((segment) =>
      normalizeCardPath(`${basePath}${segment}`)
    )
  }

  var createCardRoute = function (routes, path, key, card, initialCardStack) {
    if (initialCardStack == null) {
      initialCardStack = []
    }
    const paths = getCardPaths(path, key, card)

    for (const resolvedPath of paths) {
      const stackCard = createStackCard(
        initialCardStack,
        card,
        key,
        resolvedPath
      )
      const cardStack = _.clone(initialCardStack).concat([stackCard])

      // Card/route middleware
      let onEnter = null
      const cardMiddleware = getCardStackMiddleware(cardStack)
      if (cardMiddleware.length) {
        onEnter = composeMiddleware(cardMiddleware)
      }
      let onLeave = null
      const cardLeaveMiddleware = getCardStackLeaveMiddleware(cardStack)
      if (cardLeaveMiddleware.length) {
        onLeave = composeMiddleware(cardLeaveMiddleware)
      }

      const reactRoute = {
        path: resolvedPath,
        onEnter,
        onLeave,
        cards: cardStack,
        getDefaultLaunchedFrom: stackCard.getDefaultLaunchedFrom,
        components: {
          // dummy component
          cards(props) {
            return React.createElement("div")
          },
          primary: primaryFallback
        }
      }
      routes.push(reactRoute)

      if (card.childCards) {
        for (const childKey in card.childCards) {
          const childCard = card.childCards[childKey]
          routes = createCardRoute(
            routes,
            resolvedPath,
            childKey,
            childCard,
            cardStack
          )
        }
      }
    }
    return routes
  }

  let cardRoutes = []
  for (let key in cards) {
    const card = cards[key]
    cardRoutes = createCardRoute(cardRoutes, root, key, card)
  }

  return cardRoutes
}
